<script setup>
import { useBooking } from '@/composables/useBooking';
import { GM_IMAGES, u } from '@/data/images';
import vReveal from '@/directives/reveal';

const { openBooking } = useBooking();
const bgImage = `url(${u(GM_IMAGES.giraffeSunset, 1800)})`;
</script>

<template>
  <section class="cta-banner" id="booking">
    <div class="cta-banner__bg" :style="{ backgroundImage: bgImage }" />
    <div class="wrap">
      <div class="cta-banner__inner" v-reveal>
        <span class="eyebrow eyebrow--light">Your Adventure Awaits</span>
        <h2>Your Dream Safari Starts Here</h2>
        <p>Tell us how you like to travel and we’ll craft a journey made entirely for you — at no obligation.</p>
        <button class="gm-btn gm-btn--primary gm-btn--lg" @click="openBooking()">Book Your Adventure</button>
      </div>
    </div>
  </section>
</template>
